var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "url(#paint0_linear_127_6517)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 23.9V28.1C27 31.6 25.6 33 22.1 33H17.9C14.4 33 13 31.6 13 28.1V23.9C13 20.4 14.4 19 17.9 19H22.1C25.6 19 27 20.4 27 23.9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0998 13H23.8998C20.8167 13 19.3707 14.0941 19.0695 16.739C19.0065 17.2923 19.4648 17.75 20.0217 17.75H22.0998C26.2998 17.75 28.2498 19.7 28.2498 23.9V25.9781C28.2498 26.535 28.7074 26.9933 29.2608 26.9303C31.9057 26.629 32.9998 25.1831 32.9998 22.1V17.9C32.9998 14.4 31.5998 13 28.0998 13Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_127_6517",
    x1: 1.61254e-8,
    y1: 1.20123,
    x2: 44.6575,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486722,
    stopColor: "#DF196D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7923"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.5eb1951c3ed4d09693fae3466211be58.svg";
export { ForwardRef as ReactComponent };